import React, { Fragment } from 'react'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import AllInclusiveIcon from '@material-ui/icons/AllInclusiveOutlined'
import DoneIcon from '@material-ui/icons/Done'
import ClearIcon from '@material-ui/icons/Clear'
import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'
import { makeStyles } from '@material-ui/core/styles'

const USE_INFINITY_ICON = false

const getUnlimited = () => {
  if (USE_INFINITY_ICON) {
    return <AllInclusiveIcon />
  }
  return 'Unlimited'
}

const getBoolean = value => {
  return value ? (
    <DoneIcon style={{ color: green[500] }} />
  ) : (
    <ClearIcon style={{ color: red[500] }} />
  )
}

const createData = (feature, free, paid) => {
  return {
    feature,
    free,
    paid
  }
}

const rows = [
  createData('Tasks', getUnlimited(), getUnlimited()),
  createData('Projects', '5', getUnlimited()),
  createData('Areas', '1', getUnlimited()),
  createData('Personal Kanban', getBoolean(true), getBoolean(true)),
  createData('Tags', getBoolean(true), getBoolean(true)),
  createData('Import/Export', getBoolean(true), getBoolean(true)),
  createData('Attachments', getBoolean(false), '5 GB'),
  createData('Scheduled Tasks', getBoolean(false), getBoolean(true)),
  createData('Repeating Tasks', getBoolean(false), getBoolean(true)),
  createData('Backups *', getBoolean(false), getBoolean(true))
]

const useStyles = makeStyles(theme => ({
  tableCell: {
    borderBottom: 'none',
    [theme.breakpoints.down('xs')]: {
      padding: '6px 12px 6px 9px'
    }
  },
  tableCellBold: {
    fontWeight: 500,
    borderBottom: 'none',
    [theme.breakpoints.down('xs')]: {
      padding: '6px 12px 6px 9px'
    }
  },
  button: {
    minWidth: 100
  }
}))

const SubscriptionPlans = ({ prices, subscribe = () => {}, isOffline }) => {
  const classes = useStyles()

  return (
    <Fragment>
      <TableContainer>
        <Table aria-label='Subscription Plans' size='small'>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell}></TableCell>
              <TableCell className={classes.tableCell} align='center'>
                Free Plan (Current)
              </TableCell>
              <TableCell className={classes.tableCell} align='center'>
                Single User Plan
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.feature}>
                <TableCell
                  className={classes.tableCellBold}
                  component='th'
                  scope='row'
                  align='right'
                >
                  {row.feature}:
                </TableCell>
                <TableCell className={classes.tableCell} align='center'>
                  {row.free}
                </TableCell>
                <TableCell className={classes.tableCell} align='center'>
                  {row.paid}
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell
                className={classes.tableCell}
                component='th'
                scope='row'
                align='right'
              ></TableCell>
              <TableCell
                className={classes.tableCell}
                align='center'
              ></TableCell>
              <TableCell align='center'>
                <br />
                {prices.map(price => (
                  <Fragment key={price.id}>
                    <Button
                      className={classes.button}
                      id={price.id}
                      variant='contained'
                      color='secondary'
                      onClick={() => subscribe(price)}
                      disabled={isOffline}
                      size='small'
                    >
                      {price.priceCost}
                    </Button>
                    <br />
                    <br />
                  </Fragment>
                ))}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant='caption'>
        * Continuous Point-in-time backups
      </Typography>
    </Fragment>
  )
}

export default SubscriptionPlans
